import { Button } from "@heroui/react";
import React from "react";

import {
  formatDate,
  getPreviousWeekKey,
  getNextWeekKey,
  isCurrentWeek,
  getCurrentWeekKey,
  parseWeekKey,
} from "@wc/domain/dates";

/**
 * Week navigation component
 * @param {object} props Component props
 * @param {string} props.currentWeek Current week key (yyyy-MM-dd)
 * @param {function(string): void} props.onWeekChange Callback when week changes
 * @returns {React.ReactElement} Week navigation
 */
export default function WeekNavigation({ currentWeek, onWeekChange }) {
  // Convert yyyy-MM-dd to Date for display formatting
  const displayDate = parseWeekKey(currentWeek);
  const isCurrentWeekSelected = isCurrentWeek(currentWeek);

  return (
    <div className="flex items-center justify-center gap-2 py-4">
      <Button
        size="sm"
        isIconOnly
        variant="flat"
        onPress={() => onWeekChange(getPreviousWeekKey(currentWeek))}
        aria-label="Previous week"
      >
        ←
      </Button>

      <span className="min-w-[200px] text-center text-lg font-semibold">
        Week of {formatDate(displayDate)}
      </span>

      <Button
        size="sm"
        isIconOnly
        variant="flat"
        onPress={() => onWeekChange(getNextWeekKey(currentWeek))}
        isDisabled={isCurrentWeekSelected}
        aria-label="Next week"
      >
        →
      </Button>

      {!isCurrentWeekSelected && (
        <Button
          size="sm"
          color="primary"
          variant="flat"
          onPress={() => onWeekChange(getCurrentWeekKey())}
        >
          This Week
        </Button>
      )}
    </div>
  );
}
